import React from "react";

// Hand-drawn style botanical line-art. Color via text-* (uses currentColor).
const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const LeafSprig = ({ className = "" }) => (
  <svg viewBox="0 0 120 130" className={className} {...base} aria-hidden="true">
    <path d="M60 125 C60 96 60 52 60 12" />
    <path d="M60 104 C41 101 29 87 27 69 C47 71 58 85 60 104 Z" />
    <path d="M60 104 C79 101 91 87 93 69 C73 71 62 85 60 104 Z" />
    <path d="M60 74 C43 71 33 58 31 42 C49 44 58 58 60 74 Z" />
    <path d="M60 74 C77 71 87 58 89 42 C71 44 62 58 60 74 Z" />
    <path d="M60 46 C47 44 41 33 40 22 C53 24 59 35 60 46 Z" />
  </svg>
);

export const CitrusSlice = ({ className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} {...base} aria-hidden="true">
    <circle cx="50" cy="50" r="44" />
    <circle cx="50" cy="50" r="35" />
    <path d="M50 15 V50 M85 50 H50 M50 85 V50 M15 50 H50" />
    <path d="M74.7 25.3 L50 50 M25.3 25.3 L50 50 M74.7 74.7 L50 50 M25.3 74.7 L50 50" />
  </svg>
);

export const HerbSprig = ({ className = "" }) => (
  <svg viewBox="0 0 70 130" className={className} {...base} aria-hidden="true">
    <path d="M35 126 C35 92 35 46 35 8" />
    <path d="M35 106 C25 103 20 95 19 86" />
    <path d="M35 106 C45 103 50 95 51 86" />
    <path d="M35 86 C25 83 20 75 19 66" />
    <path d="M35 86 C45 83 50 75 51 66" />
    <path d="M35 66 C26 63 22 56 21 48" />
    <path d="M35 66 C44 63 48 56 49 48" />
    <path d="M35 46 C28 43 25 37 24 30" />
    <path d="M35 46 C42 43 45 37 46 30" />
    <path d="M35 26 C31 24 29 19 29 14" />
    <path d="M35 26 C39 24 41 19 41 14" />
  </svg>
);

export const BerryBranch = ({ className = "" }) => (
  <svg viewBox="0 0 120 120" className={className} {...base} aria-hidden="true">
    <path d="M14 20 C40 40 70 62 104 96" />
    <circle cx="30" cy="34" r="9" />
    <circle cx="52" cy="50" r="9" />
    <circle cx="74" cy="66" r="9" />
    <circle cx="96" cy="82" r="9" />
    <path d="M40 22 C48 18 58 20 62 28" />
    <path d="M66 44 C74 40 84 42 88 50" />
  </svg>
);

export const AvocadoDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 90 120" className={className} {...base} aria-hidden="true">
    <path d="M45 14 C64 14 74 40 74 64 C74 92 62 112 45 112 C28 112 16 92 16 64 C16 40 26 14 45 14 Z" />
    <path d="M45 30 C57 30 63 46 63 62 C63 82 56 96 45 96 C34 96 27 82 27 62 C27 46 33 30 45 30 Z" />
    <circle cx="45" cy="70" r="14" />
  </svg>
);
